var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001Haus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 486.733,
    width: 486.733,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_26",
    height: 163.255,
    width: 42.192,
    y: 243.914,
    x: 85.202,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_44",
    height: 80.222,
    width: 31.531,
    y: 390.864,
    x: 162.548,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_40",
    height: 21.025,
    width: 103.861,
    y: 382.039,
    x: 118.466,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_39",
    height: 45.431,
    width: 74.65,
    y: 381.093,
    x: 147.678,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    height: 179.755,
    width: 15.942,
    y: 243.914,
    x: 85.202,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_4",
    d: "m158.560091,427.995067c-2.811469,-16.882537 -17.040016,-29.772071 -34.114111,-29.772071c-13.632987,0 -25.445212,8.2149 -31.088435,20.120699c-1.114851,-0.825529 -2.305972,-1.558492 -3.531172,-2.219083l0,-118.435266c0,-3.963551 -3.101947,-7.180674 -6.923597,-7.180674c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,114.894999c-15.273618,0 -27.695199,12.882802 -27.695199,28.724381s12.42158,28.723539 27.695199,28.723539l76.162811,0c11.451968,0 20.771602,-9.665678 20.771602,-21.542865c0,-9.557963 -6.031067,-17.679455 -14.353501,-20.494333zm-6.4181,27.675008l-76.162811,0c-7.636809,0 -13.848005,-6.44098 -13.848005,-14.36219s6.211196,-14.361349 13.848005,-14.361349c6.460293,0 12.200071,3.892022 14.283722,9.694289c1.170025,3.253309 4.41072,5.170288 7.720382,4.552613c3.295869,-0.617674 5.691094,-3.590758 5.691094,-7.066228c0,-11.877187 9.319634,-21.542865 20.771602,-21.542865s20.771602,9.665678 20.771602,21.542865c0,3.963551 3.101947,7.180674 6.923597,7.180674c3.815159,0 6.923597,3.223856 6.923597,7.180674s-3.107626,7.181516 -6.922785,7.181516l0,0.000001z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_28",
    height: 279.384,
    width: 42.192,
    y: 147.139,
    x: 180.135,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_29",
    height: 84.993,
    width: 273.171,
    y: 202.784,
    x: 127.394,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_41",
    height: 48.797,
    width: 68.158,
    y: 380.356,
    x: 296.148,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_42",
    height: 29.441,
    width: 120.09,
    y: 380.356,
    x: 294.541,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_31",
    height: 163.255,
    width: 42.192,
    y: 245.597,
    x: 386.213,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_30",
    height: 288.642,
    width: 42.192,
    y: 153.871,
    x: 293.73,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_34",
    height: 127.069,
    width: 30.833,
    y: 124.523,
    x: 274.256,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_35",
    height: 127.069,
    width: 30.833,
    y: 117.791,
    x: 208.534,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_36",
    height: 73.212,
    width: 38.947,
    y: 84.972,
    x: 237.744,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.5636393400477627,0.6053375078436606,-0.583665622664369,0.5845676362943123,141.35197203166516,-64.18859644247446)",
    id: "svg_37",
    height: 273.922,
    width: 52.737,
    y: 18.68,
    x: 224.668,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_55",
    height: 137.075,
    width: 110.358,
    y: 105.233,
    x: 342.188,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-45 323.44903564453114,184.19152832031247)",
    id: "svg_38",
    height: 252.5,
    width: 52.737,
    y: 57.942,
    x: 297.081,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_43",
    height: 39.632,
    width: 142.81,
    y: 432.533,
    x: 197.981,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_3",
    height: 175.63,
    width: 17.532,
    y: 247.49,
    x: 410.872,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_11",
    height: 79.323,
    width: 22.816,
    y: 379.409,
    x: 327.172,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_6",
    d: "m436.02082,412.584345l0,-114.894999c0,-3.963551 -3.101947,-7.180674 -6.923597,-7.180674s-6.923597,3.217124 -6.923597,7.180674l0,118.435266c-1.2252,0.660592 -2.416321,1.392713 -3.531172,2.219083c-5.643222,-11.905799 -17.455448,-20.120699 -31.088435,-20.120699c-17.074094,0 -31.302642,12.889534 -34.114111,29.772071c-8.322434,2.814878 -14.353501,10.93637 -14.353501,20.494333c0,2.534653 0.498194,4.926247 1.281186,7.180674l-118.9872,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674s3.101947,7.180674 6.923597,7.180674l138.477616,0l27.695199,0l48.466801,0c15.27443,0.000842 27.69601,-12.88196 27.69601,-28.722698s-12.42158,-28.724381 -27.695199,-28.724381l0,0.000002zm0,43.08573l-48.466801,0l-27.69601,0c-3.815159,0 -6.923597,-3.223856 -6.923597,-7.180674s3.108438,-7.180674 6.923597,-7.180674c3.82165,0 6.923597,-3.217124 6.923597,-7.180674c0,-11.877187 9.319634,-21.542865 20.771602,-21.542865s20.771602,9.665678 20.771602,21.542865c0,3.47547 2.396037,6.448554 5.691094,7.066228c3.288566,0.624406 6.550357,-1.300146 7.720382,-4.552613c2.083651,-5.802268 7.824241,-9.694289 14.283722,-9.694289c7.636809,0 13.848005,6.44098 13.848005,14.36219s-6.210384,14.360507 -13.847194,14.360507l0.000001,-0.000001z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_7",
    d: "m283.695199,182.794346c0,-15.841579 -12.42158,-28.723539 -27.695199,-28.723539c-15.27443,0 -27.695199,12.882802 -27.695199,28.723539s12.420769,28.723539 27.695199,28.723539c15.27443,0 27.695199,-12.882802 27.695199,-28.723539zm-41.543204,0c0,-7.920369 6.210384,-14.36219 13.848005,-14.36219c7.636809,0 13.848005,6.44098 13.848005,14.36219c0,7.920369 -6.210384,14.36219 -13.848005,14.36219c-7.636809,-0.000842 -13.848005,-6.441822 -13.848005,-14.36219z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_8",
    d: "m387.553208,283.327155l-55.391209,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,78.990785l-6.923597,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674s3.101947,7.180674 6.923597,7.180674l83.086407,0c3.82165,0 6.923597,-3.217124 6.923597,-7.180674s-3.101947,-7.180674 -6.923597,-7.180674l-6.923597,0l0,-78.990785c0,-3.963551 -3.101947,-7.180674 -6.924408,-7.180674l0.000001,0zm-6.923597,86.17146l-41.543204,0l0,-28.723539l41.543204,0l0,28.723539zm0,-43.08573l-41.543204,0l0,-28.723539l41.543204,0l0,28.723539z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_9",
    d: "m325.874784,434.12721c0,-3.963551 -3.101947,-7.180674 -6.923597,-7.180674l-20.771602,0l0,-136.437864c0,-3.963551 -3.101947,-7.180674 -6.923597,-7.180674l-69.238402,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,136.437864l-20.771602,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,28.723539c0,3.963551 3.101947,7.180674 6.923597,7.180674s6.923597,-3.217124 6.923597,-7.180674l0,-21.542865l117.705203,0c3.82165,0.000842 6.923597,-3.216282 6.923597,-7.180674zm-41.543204,-78.989944l-6.923597,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674s3.101947,7.180674 6.923597,7.180674l6.923597,0l0,57.44792l-55.391209,0l0,-129.25719l55.391209,0l0,57.44792l0,0.000002z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_10",
    d: "m179.837189,283.327155l-55.390397,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,78.990785l-6.924408,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674s3.101947,7.181516 6.923597,7.181516l83.086407,0c3.82165,0 6.923597,-3.217124 6.923597,-7.180674s-3.101947,-7.180674 -6.923597,-7.180674l-6.923597,0l0,-78.990785c0,-3.964392 -3.101947,-7.181516 -6.924408,-7.181516zm-6.923597,86.17146l-41.543204,0l0,-28.723539l41.543204,0l0,28.723539zm0,-43.08573l-41.543204,0l0,-28.723539l41.543204,0l0,28.723539z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.191801,102.643595c0.811391,0 5.679735,0 10.548087,0c4.05697,0 8.967863,0.719742 14.605057,0c3.320381,-0.423932 4.056953,-0.841518 4.86836,-0.841518c0.811391,0 1.622781,0 1.622781,0.841518l0.811391,0.841518l0.811391,0",
    id: "svg_32",
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "none",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-135 130.78097534179688,188.95912170410156)",
    id: "svg_45",
    height: 206.868,
    width: 26.019,
    y: 85.525,
    x: 117.771,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_46",
    height: 137.075,
    width: 42.192,
    y: 103.363,
    x: 61.161,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_47",
    height: 102.791,
    width: 42.192,
    y: 102.74,
    x: 81.596,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_48",
    height: 84.091,
    width: 42.192,
    y: 104.61,
    x: 105.036,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_49",
    height: 61.651,
    width: 42.192,
    y: 103.363,
    x: 124.268,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_50",
    height: 34.224,
    width: 38.586,
    y: 103.363,
    x: 148.91,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_51",
    height: 16.826,
    width: 28.97,
    y: 104.756,
    x: 181.966,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_52",
    height: 88.454,
    width: 23.561,
    y: 49.133,
    x: 139.895,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_53",
    height: 23.627,
    width: 47.001,
    y: 49.133,
    x: 129.677,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_54",
    height: 9.749,
    width: 45.109,
    y: 103.106,
    x: 180.764,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_56",
    height: 84.091,
    width: 42.192,
    y: 108.35,
    x: 368.884,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_57",
    height: 34.224,
    width: 38.586,
    y: 110.843,
    x: 331.62,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_58",
    height: 16.826,
    width: 28.97,
    y: 103.931,
    x: 305.175,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.5836656226643692,-0.5845676362943122,0.5636393400477626,0.6053375078436607,-6.632552241982397,282.6001109530559)",
    id: "svg_60",
    height: 252.035,
    width: 32.358,
    y: 126.654,
    x: 405.716,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.5836656226643692,-0.5845676362943122,0.5636393400477626,0.6053375078436607,7.741621227512592,285.5469858782794)",
    id: "svg_61",
    height: 192.944,
    width: 49.19,
    y: 136.027,
    x: 410.491,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 17.009,
    width: 33.018,
    y: 103.106,
    x: 292.029,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_5",
    d: "m456.792422,97.282897l-131.554019,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674s3.101947,7.180674 6.923597,7.180674l124.629611,0l0,155.008487l-188.972894,-195.98958c-1.357457,-1.40786 -3.136836,-2.103795 -4.916216,-2.103795s-3.55876,0.696777 -4.916216,2.103795l-188.930701,195.982007l0,-155.000914l76.162811,0c3.82165,0 6.923597,-3.217124 6.923597,-7.180674l0,-28.723539c0,-3.963551 -3.101947,-7.180674 -6.923597,-7.180674l-6.924408,0l0,-14.36219l41.543204,0l0,14.36219l-6.923597,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,28.723539c0,3.963551 3.101947,7.180674 6.923597,7.180674l20.771602,0c3.82165,0 6.923597,-3.217124 6.923597,-7.180674s-3.101947,-7.180674 -6.923597,-7.180674l-13.848005,0l0,-14.36219l6.923597,0c3.82165,0 6.923597,-3.217124 6.923597,-7.180674l0,-28.724381c0,-3.963551 -3.101947,-7.180674 -6.923597,-7.180674l-55.390397,0c-3.82165,0 -6.923597,3.217124 -6.923597,7.180674l0,28.723539c0,3.963551 3.101947,7.180674 6.923597,7.180674l6.923597,0l0,14.36219l-76.162811,0c-1.834554,0 -3.600141,0.754 -4.89512,2.103795c-1.301471,1.343905 -2.028477,3.175048 -2.028477,5.077721l0.027587,179.523594c0,2.908287 1.689315,5.522042 4.279275,6.635371c0.858451,0.36606 1.751793,0.546145 2.645134,0.546145c1.806967,0 3.579856,-0.732121 4.89512,-2.103795l195.847807,-203.192976l195.917587,203.192134c1.322567,1.371675 3.094644,2.103795 4.89512,2.103795c0.893341,0 1.793173,-0.179243 2.651625,-0.546145c2.582657,-1.113329 4.271972,-3.733816 4.271972,-6.635371l0,-179.522753c0.000811,-3.963551 -3.101135,-7.180674 -6.922785,-7.180674l-0.000003,0.000001z",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Haus);
export default __webpack_public_path__ + "static/media/001 Haus.e8c20bef37a83fdbc3770d473ddf9949.svg";
export { ForwardRef as ReactComponent };